import * as constants from '../constants';

export default function ( title ) {
  const textColour = 0xFFFFFF;

  const c = new PIXI.Container();

  const g = new PIXI.Graphics();
  c.addChild(g);
  g
  .clear()
  .beginFill(constants.lightBlue)
  .drawRect(0, 0, constants.screenWidth, constants.headerHeight)
  .endFill();

  const text = new PIXI.Text(title, {
    font: '24px Open Sans, Arial',
    fill: textColour,
    align: 'center',
    letterSpacing: 3
  });
  c.addChild(text);
  text.anchor.set(0.5);
  text.position.set(constants.screenWidth / 2, constants.headerHeight / 2);

  return c;
};
